export default "__VITE_ASSET__CYFPwvHJ__"